const DISMISS_KEY = "royallty-install-dismiss";
const DISMISS_DAYS = 7;

export function isStandalone() {
  return (
    window.matchMedia("(display-mode: standalone)").matches ||
    window.navigator.standalone === true
  );
}

export function isIOS() {
  return (
    /iPad|iPhone|iPod/i.test(navigator.userAgent) ||
    (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1)
  );
}

export function isAndroid() {
  return /Android/i.test(navigator.userAgent);
}

export function isMobileDevice() {
  return (
    isIOS() ||
    isAndroid() ||
    window.matchMedia("(max-width: 768px)").matches
  );
}

export function isInstallDismissed() {
  try {
    const raw = localStorage.getItem(DISMISS_KEY);
    if (!raw) return false;
    const { until } = JSON.parse(raw);
    return Date.now() < until;
  } catch {
    return false;
  }
}

export function dismissInstallPrompt() {
  localStorage.setItem(
    DISMISS_KEY,
    JSON.stringify({ until: Date.now() + DISMISS_DAYS * 86400000 }),
  );
}

export function canUseNativeInstall() {
  return (
    typeof window !== "undefined" &&
    "serviceWorker" in navigator &&
    window.isSecureContext
  );
}
